import Checkbox from "../utilities/Checkbox";

const ScheduleCheckbox = ({ scheduled, setScheduled, scheduledDate, setScheduledDate, style={} }) => {
    return (
        <div>
            <div style={{ marginTop: "5px" }}>
                <Checkbox
                    label={"Schedule Invitation Email"}
                    value={scheduled}
                    setValue={(e) => setScheduled(e.target.checked)}
                />
            </div>
            {scheduled && (
                <div style={{ marginTop: "10px", ... style }}>
                    <input
                        type="datetime-local"
                        min={new Date().toISOString().slice(0, 16)}
                        value={scheduledDate}
                        onChange={(e) => setScheduledDate(e.target.value)}
                        style={{
                            padding: "5px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default ScheduleCheckbox;